export default "__VITE_ASSET__DDb7gnNy__"